// Entity-agnostic URL parsing; domain-bound parsers stay with their route. Twin of the
// admin-panel's on purpose: apps/frontend/docs/razionale-che-il-codice-indica.md

// A positive integer, or null. `/^\d+$/` and not `Number()`, which accepts '0x10', '1e3',
// ' 7 ' and '' (that one becomes 0); ids start at 1 (Identity(always=True)).
export function parsePositiveInt(value: unknown): number | null {
  const text = typeof value === 'number' ? String(value) : value
  if (typeof text !== 'string' || !/^\d+$/.test(text)) return null
  const parsed = Number.parseInt(text, 10)
  return parsed >= 1 ? parsed : null
}

// A value validated against a closed list, or null: an invented one becomes "no value"
// instead of reaching the backend, where it would 422 a mistyped link.
export function parseOneOf<TValue extends string>(
  values: readonly TValue[],
  value: unknown,
): TValue | null {
  if (typeof value !== 'string') return null
  return values.includes(value as TValue) ? (value as TValue) : null
}

/** One `$id` path param, both directions. `parse` returning `false` means "this route does
 *  not match", so /matches/abc falls through instead of asking the API:
 *  apps/frontend/docs/razionale-che-il-codice-indica.md. */
export function numericIdParam<TName extends string>(name: TName) {
  return {
    parse: (raw: Record<string, string>): Record<TName, number> | false => {
      const id = parsePositiveInt(raw[name])
      return id === null ? false : ({ [name]: id } as Record<TName, number>)
    },
    stringify: (params: Record<TName, number>): Record<TName, string> =>
      ({ [name]: String(params[name]) }) as Record<TName, string>,
  }
}
